import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface LoadingProps {
  onComplete: () => void;
}

const Loading: React.FC<LoadingProps> = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onComplete, 1000);
    }, 3000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          className="fixed inset-0 bg-black z-50 flex items-center justify-center"
        >
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{
              scale: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
              opacity: { duration: 0.8 }
            }}
            className="text-center"
          >
            <motion.h1
              initial={{ y: 20, opacity: 0 }}
              animate={{ 
                y: 0, 
                opacity: 1,
                textShadow: [
                  "0 0 5px #fff, 0 0 10px #fff, 0 0 15px #ff8c00, 0 0 20px #ff8c00, 0 0 25px #ff8c00",
                  "0 0 2px #fff, 0 0 5px #fff, 0 0 7px #ff6a00, 0 0 10px #ff6a00",
                  "0 0 5px #fff, 0 0 10px #fff, 0 0 15px #ff8c00, 0 0 20px #ff8c00, 0 0 25px #ff8c00"
                ]
              }}
              transition={{ 
                delay: 0.2, 
                duration: 0.8,
                textShadow: {
                  repeat: Infinity,
                  duration: 2,
                  repeatType: "reverse"
                }
              }}
              className="text-6xl md:text-8xl font-serif font-bold text-white mb-4"
            >
              Fastiny
            </motion.h1>
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8, duration: 0.5 }}
              className="text-2xl md:text-3xl text-white/80 font-light mb-6"
            >
              ENTERTAINMENT BAR
            </motion.p>
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: '100%' }}
              transition={{ delay: 0.5, duration: 1.5, ease: 'easeInOut' }}
              className="h-1 bg-[#ff8c00] mx-auto max-w-xs"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loading; 